import ColostrumPage from "./ColostrumPage";

export default function App() {
  return <ColostrumPage />;
}
